import React, { useMemo, useState } from 'react';
import '../Fabric/fabric.css'; // Reusing fabric styles
import NavBar from '../Navbar';
import Foot from '../footer';

// Base Model Imports (from renders/MODEL_1)
import model_body from '../assets/renders/MODEL_1/BODY.png';
import hand_cuff from '../assets/renders/MODEL_1/HAND_FOR_CUFF_SLEEVE.png';
import hand_non_cuff from '../assets/renders/MODEL_1/HAND_FOR_NON_CUFF_SLEEVE.png';

// Kurta Render Imports (from renders/KURTA/1ST)
const kurtaImages = {
  "BE": require("../assets/renders/KURTA/1ST/BE.webp"),
  "BKC": require("../assets/renders/KURTA/1ST/BKC.webp"),
  "BKN": require("../assets/renders/KURTA/1ST/BKN.webp"),
  "BPL": require("../assets/renders/KURTA/1ST/BPL.webp"),
  "BPR": require("../assets/renders/KURTA/1ST/BPR.webp"),
  "CB": require("../assets/renders/KURTA/1ST/CB.webp"),
  "CC": require("../assets/renders/KURTA/1ST/CC.webp"),
  "CE": require("../assets/renders/KURTA/1ST/CE.webp"),
  "CM": require("../assets/renders/KURTA/1ST/CM.webp"),
  "CN": require("../assets/renders/KURTA/1ST/CN.webp"),
  "CR": require("../assets/renders/KURTA/1ST/CR.webp"),
  "CS": require("../assets/renders/KURTA/1ST/CS.webp"),
  "CT": require("../assets/renders/KURTA/1ST/CT.webp"),
  "D": require("../assets/renders/KURTA/1ST/D.webp"),
  "FLN": require("../assets/renders/KURTA/1ST/FLN.webp"),
  "FLR": require("../assets/renders/KURTA/1ST/FLR.webp"),
  "FLS": require("../assets/renders/KURTA/1ST/FLS.webp"),
  "FRN": require("../assets/renders/KURTA/1ST/FRN.webp"),
  "FRR": require("../assets/renders/KURTA/1ST/FRR.webp"),
  "FRS": require("../assets/renders/KURTA/1ST/FRS.webp"),
  "LN": require("../assets/renders/KURTA/1ST/LN.webp"),
  "LR": require("../assets/renders/KURTA/1ST/LR.webp"),
  "LS": require("../assets/renders/KURTA/1ST/LS.webp"),
  "NH0": require("../assets/renders/KURTA/1ST/NH0.webp"),
  "NS0": require("../assets/renders/KURTA/1ST/NS0.webp"),
  "NS3": require("../assets/renders/KURTA/1ST/NS3.webp"),
  "NS4": require("../assets/renders/KURTA/1ST/NS4.webp"),
  "QH0": require("../assets/renders/KURTA/1ST/QH0.webp"),
  "QS0": require("../assets/renders/KURTA/1ST/QS0.webp"),
  "QS3": require("../assets/renders/KURTA/1ST/QS3.webp"),
  "QS4": require("../assets/renders/KURTA/1ST/QS4.webp"),
  "R-COAT": require("../assets/renders/KURTA/1ST/R-COAT.webp"),
  "R-SADRI": require("../assets/renders/KURTA/1ST/R-SADRI.webp"),
  "R": require("../assets/renders/KURTA/1ST/R.webp"),
  "RN": require("../assets/renders/KURTA/1ST/RN.webp"),
  "RR": require("../assets/renders/KURTA/1ST/RR.webp"),
  "RS": require("../assets/renders/KURTA/1ST/RS.webp"),
  "S-COAT": require("../assets/renders/KURTA/1ST/S-COAT.webp"),
  "S-SADRI": require("../assets/renders/KURTA/1ST/S-SADRI.webp"),
  "S": require("../assets/renders/KURTA/1ST/S.webp"),
  "SC-SADRI": require("../assets/renders/KURTA/1ST/SC-SADRI.webp"),
  "SC": require("../assets/renders/KURTA/1ST/SC.webp"),
  "SE": require("../assets/renders/KURTA/1ST/SE.webp"),
  "SN-SADRI": require("../assets/renders/KURTA/1ST/SN-SADRI.webp"),
  "SN": require("../assets/renders/KURTA/1ST/SN.webp"),
  "T": require("../assets/renders/KURTA/1ST/T.webp"),
};

// Options Configuration
const options = {
  bottomCut: { label: "Bottom Cut", options: ["R", "S"] }, // Round, Straight
  neckPlacket: { label: "Neck Placket", options: ["NS", "QS"] }, // Normal, Q Style
  pocketCount: { label: "Pocket Count", options: ["00", "01", "11"] }, // None, 1, 2
  pocketType: { label: "Pocket Type", options: ["R", "N", "S"] }, // Round, Normal, Square
  flap: { label: "Flap", options: ["0", "1"] }, // No, Yes
  flapType: { label: "Flap Type", options: ["R", "N", "S"] }, // Round, Normal, Square
  epaulette: { label: "Epaulette", options: ["0", "SE"] }, // No, Shoulder Epaulette
  collar: { label: "Collar", options: ["CN", "CA", "CC", "CR", "CB", "CS", "CT", "CE"] },
  sleeve: { label: "Sleeve", options: ["SN", "SC"] } // Normal, Cuff
};

const TestKurtaDesign = () => {
  // Initial State: [bottomCut, neckPlacket, pocketCount, pocketType, flap, flapType, epaulette, collar, sleeve]
  const [F, setF] = useState(["R", "NS", "11", "R", "1", "R", "SE", "CN", "SN"]);

  const updateF = (index, value) => {
    const newF = [...F];
    newF[index] = value;
    setF(newF);
  };

  const kurtaLayers = useMemo(() => {
    const layers = [];
    
    // Attributes mapping
    const bottomCut = F[0]; 
    const neckPlacket = F[1];
    const pocketCount = F[2];
    const pocketType = F[3];
    const flap = F[4];
    const flapType = F[5];
    const epaulette = F[6];
    const collar = F[7];
    const sleeve = F[8];

    const addLayer = (code, z) => {
      if (kurtaImages[code]) {
        layers.push({ z: 100 - z, src: kurtaImages[code] });
      }
    };

    // 0. Body (Excel Z=20 -> CSS 80)
    layers.push({ z: 80, src: model_body, isModel: true });

    // 0.5 Hands (Excel Z=3 -> CSS 97)
    // Hands logic: behind Sleeve (Z=2 -> 98) but in front of Base (Z=8 -> 92)
    // CSS 97 puts it behind Sleeve (98) and in front of Base (92)
    layers.push({ z: 97, src: sleeve === "SC" ? hand_cuff : hand_non_cuff, isModel: true, isHands: true });

    // 1. Epaulette (Z=1)
    if (epaulette === "SE") addLayer("SE", 1);

    // 2. Sleeve (Z=2)
    if (sleeve === "SC") addLayer("SC", 2);
    else addLayer("SN", 2);

    // 3. Neck Placket (Z=4)
    let isPathani = false;
    if (["CC", "CR", "CB", "CS", "CT", "CE"].includes(collar)) {
        isPathani = true;
    }

    let placketCode = "";
    if (neckPlacket === "NS") placketCode = isPathani ? "NS3" : "NS4";
    else if (neckPlacket === "QS") placketCode = isPathani ? "QS3" : "QS4";
    addLayer(placketCode, 4);

    // 4. Pockets (Z=6)
    const pType = pocketType; 
    
    if (pocketCount === "01" || pocketCount === "11") {
        addLayer("L" + pType, 6); 
        if (flap === "1") addLayer("FL" + flapType, 6);
    }
    
    if (pocketCount === "11") {
        addLayer("R" + pType, 6); 
        if (flap === "1") addLayer("FR" + flapType, 6);
    }

    // 5. Buttons (Z=7)
    addLayer(isPathani ? "BKN" : "BKC", 7);
    
    if (flap === "1") {
        if (pocketCount === "01" || pocketCount === "11") addLayer("BPL", 7);
        if (pocketCount === "11") addLayer("BPR", 7);
    }
    
    if (epaulette === "SE") addLayer("BE", 7);

    // 6. Base (Z=8)
    let baseCode = "";
    if (isPathani) {
        baseCode = bottomCut === "S" ? "T" : "D";
    } else {
        baseCode = bottomCut === "S" ? "S" : "R";
    }
    addLayer(baseCode, 8);

    // 7. Collar (Z=8)
    let collarCode = collar === "CA" ? "CN" : collar;
    addLayer(collarCode, 8);
    
    return layers.sort((a, b) => a.z - b.z);
  }, [F]);

  return (
    <>
      <NavBar flag={1} />
      <div className="container-fluid" style={{ marginTop: '100px', minHeight: '80vh', display: 'flex' }}>
        
        {/* Left Side: Controls */}
        <div style={{ width: '300px', padding: '20px', borderRight: '1px solid #ccc', maxHeight: '80vh', overflowY: 'auto' }}>
            <h4>Design Customization</h4>
            <p className="text-muted small">Adjust options to test renders</p>
            
            {Object.keys(options).map((key, index) => (
                <div key={key} className="mb-3">
                    <label className="form-label"><strong>{options[key].label}</strong></label>
                    <select 
                        className="form-select"
                        value={F[index]}
                        onChange={(e) => updateF(index, e.target.value)}
                    >
                        {options[key].options.map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                        ))}
                    </select>
                </div>
            ))}

            <div className="mt-4">
                <h5>Current Logic Check</h5>
                <ul className="small text-muted">
                    <li>Collar: {F[7]} ({["CC", "CR", "CB", "CS", "CT", "CE"].includes(F[7]) ? "Pathani" : "Kurta"})</li>
                    <li>Sleeve: {F[8]}</li>
                    <li>Base: {F[0] === "S" ? "Straight" : "Round"}</li>
                </ul>
            </div>
        </div>

        {/* Right Side: Display */}
        <div style={{ flex: 1, position: 'relative', display: 'flex', justifyContent: 'center', backgroundColor: '#f8f9fa', overflowY: 'auto' }}>
            <div className="v-d-body" style={{ position: 'relative', width: '100%', maxWidth: '600px', minHeight: '80vh', height: 'auto', paddingBottom: '200px', overflow: 'visible' }}>
                {kurtaLayers.map((layer, idx) => (
                    <img 
                        key={idx} 
                        src={layer.src} 
                        className={`v-display-img-full v-display-img-kurta`}
                        style={{ 
                            zIndex: layer.z, 
                            position: idx === 0 ? 'relative' : 'absolute', // First layer (Model Body) sets height
                            top: (layer.isModel && !layer.isHands) ? 0 : (layer.isHands ? '10px' : '-20px'), 
                            left: (layer.isModel && !layer.isHands) ? '50%' : (layer.isHands ? 'calc(50% - 20px)' : 'calc(50% - 40px)'), 
                            width: '100%', 
                            height: 'auto', 
                            transform: layer.isModel ? 'translateX(-50%) scale(1.15)' : 'translateX(-50%)',
                            transformOrigin: 'top center'
                        }}
                        alt={`layer-${idx}`}
                    />
                ))}
            </div>
        </div>

      </div>
      <Foot />
    </>
  );
};

export default TestKurtaDesign;
